import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";

import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";

export default function ProductCard({ product }) {
  const [isInWishlist, setIsInWishlist] = useState(false);

  useEffect(() => {
    const checkWishlist = () => {
      const token = localStorage.getItem("access_token");
      if (token && product) {
        try {
          const stored = localStorage.getItem("wishlist_slugs");
          if (stored) {
            const slugs = JSON.parse(stored);
            setIsInWishlist(slugs.includes(product.slug));
          } else {
            setIsInWishlist(false);
          }
        } catch (e) {
          setIsInWishlist(false);
        }
      } else {
        setIsInWishlist(false);
      }
    };
    checkWishlist();

    window.addEventListener("wishlist-slugs-updated", checkWishlist);
    window.addEventListener("wishlist-updated", checkWishlist);
    return () => {
      window.removeEventListener("wishlist-slugs-updated", checkWishlist);
      window.removeEventListener("wishlist-updated", checkWishlist);
    };
  }, [product]);

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("access_token");
    if (!token) {
      alert("Please login first to manage your wishlist.");
      const loginPath = "/login";
      window.location.href = loginPath;
      return;
    }

    try {
      let storedSlugs = [];
      try {
        const stored = localStorage.getItem("wishlist_slugs");
        if (stored) storedSlugs = JSON.parse(stored);
      } catch (err) {}

      if (isInWishlist) {
        const res = await axios.get(`/wishlists-remove-product/${product.slug}`);
        if (res.status === 200) {
          setIsInWishlist(false);
          const updated = storedSlugs.filter(s => s !== product.slug);
          localStorage.setItem("wishlist_slugs", JSON.stringify(updated));
          window.dispatchEvent(new CustomEvent("wishlist-updated"));
          window.dispatchEvent(new CustomEvent("wishlist-slugs-updated"));
        }
      } else {
        const res = await axios.get(`/wishlists-add-product/${product.slug}`);
        if (res.status === 200) {
          setIsInWishlist(true);
          if (!storedSlugs.includes(product.slug)) {
            storedSlugs.push(product.slug);
          }
          localStorage.setItem("wishlist_slugs", JSON.stringify(storedSlugs));
          window.dispatchEvent(new CustomEvent("wishlist-updated"));
          window.dispatchEvent(new CustomEvent("wishlist-slugs-updated"));
        }
      }
    } catch (err) {
      console.error("Error toggling wishlist:", err);
    }
  };

  return (
    <div className="product_card">
      <div className="product_img">
        <Link to={`/product/${product.slug}`}>
          <img src={product.thumbnail_image} alt={product.name} className="img1" />
          <img src={product.hover_image || product.thumbnail_image} alt={product.name} className="img2" />
        </Link>
        <div className="wishlist_icon">
          <a href="#" onClick={handleWishlistClick} style={{ color: isInWishlist ? '#ff3f6c' : '' }}>
            {isInWishlist ? <FavoriteIcon /> : <FavoriteBorderOutlinedIcon />}
          </a>
        </div>
      </div>
      <div className="product_details">
        <Link to={`/product/${product.slug}`}>
          <h3>{product.name}</h3>
        </Link>

        <div className="stars">
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
        </div>

        <div className="product_price">
          {product.has_discount && (
            <del>{product.stroked_price}</del>
          )}
          <p className="main_price">{product.main_price}</p>
        </div>
      </div>
    </div>
  );
}
